import {
    PROFILE_CHANGE_PASSWORD,
    PROFILE_CHANGE_PASSWORD_SUCCESS,
    PROFILE_CHANGE_PASSWORD_ERROR,
    PROFILE_CHANGE_PASSWORD_CLEAN_STATE
} from './actionTypes';

export const profileChangePassword = (params, onSubmitProps) => {
    return {
        type: PROFILE_CHANGE_PASSWORD,
        payload: { params, onSubmitProps },
    }
};

export const profileChangePasswordSuccess = () => {
    return {
        type: PROFILE_CHANGE_PASSWORD_SUCCESS,
    }
};

export const profileChangePasswordError = (data) => {
    return {
        type: PROFILE_CHANGE_PASSWORD_ERROR,
        payload: data,
    }
};

export const profileChangePasswordCleanState = () => {
    return { type: PROFILE_CHANGE_PASSWORD_CLEAN_STATE };
};